import React from 'react';
import { Dropdown, Menu, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useLocalization } from '../context/localization';
import '../index.css'
const LanguageSwitcher = () => {
    const languages = [
        { key: 'en', label: 'EN', flagSrc: '/us.png' },
        { key: 'tr', label: 'TR', flagSrc: '/tr.png' },
    ];

    const { language, changeLanguage } = useLocalization();
    const currentLanguage = languages.find(lang => lang.key === language);

    const LanguageMenu = (
        <Menu>
            {languages.map(({ key, label, flagSrc }) => (
                <Menu.Item key={key} onClick={() => changeLanguage(key)}>
                    <Space>
                        <img src={flagSrc} alt={label} />
                        <span className="language-label">{label}</span>
                    </Space>
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <Dropdown overlay={LanguageMenu}>
            <Space>
                <img src={currentLanguage?.flagSrc} alt={currentLanguage?.label} />
                <span className="language-label">{currentLanguage?.label}</span>
                <DownOutlined />
            </Space>
        </Dropdown>
    );
};

export default LanguageSwitcher;
